import { useSearchParams } from "react-router-dom";
import { Settings } from "@/features/settings/settings";

const TABS = ["organization", "notifications"] as const;
type Tab = (typeof TABS)[number];

export default function SettingsPage(){
  const [searchParams] = useSearchParams();
  const sp = Object.fromEntries(searchParams.entries());
  const initialTab: Tab = TABS.includes(sp.tab as Tab) ? (sp.tab as Tab) : "organization";
  return <Settings initialTab={initialTab} />;
}
